module.exports = __webpack_public_path__ + "f42641eed834f7b97a9499362c6c8855.woff";